import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContractsStateSlice } from "store/types/contractsSlice.types";

const initialState: ContractsStateSlice = {
  list: [],
  selectedContractId: "",
};

const contractsSlice = createSlice({
  name: "contracts",
  initialState,
  reducers: {
    setContractsList(state, action: PayloadAction<ContractsStateSlice["list"]>) {
      state.list = action.payload;
      state.selectedContractId = (action.payload[0]?.name as string) || "";
    },
    setSelectedContractId(state, action: PayloadAction<string>) {
      state.selectedContractId = action.payload;
    },
  },
});

export const { setContractsList, setSelectedContractId } = contractsSlice.actions;

export default contractsSlice.reducer;
